/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Dropdown } from 'semantic-ui-react';

export function ItemSelector(props: any) {
  return (
    <Dropdown
      {...props}
      selection
      value={props.value}
      options={props.items.map((item: any) => ({ value: item._id, text: item.name }))}
    />
  );
}
